import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VuePhoneNumberInput from "~/chat/vue/widget/form/fields/VuePhoneNumberInput/index.vue";
import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import {ClientStore} from "~/chat/ts/store/Client";
import {
    ChatFormInputInterface,
    useChatFormInput,
    useChatFormInputProps
} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {ref} from "vue";
import VuePhoneNumberInputExposeInterface
    from "~/chat/vue/widget/form/fields/VuePhoneNumberInput/VuePhoneNumberInputExposeInterface";


const __default__ = {
    name: "ChatPhoneInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue", "continue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

let input = ref<VuePhoneNumberInputExposeInterface>();

__expose<ChatFormInputInterface>({
    ...exposedObject,
    focus: () => {
        input.value?.focus();
    }
});

function emitInput(value: string) {
    emits('update:modelValue', value);
}

let countryCode = ClientStore.countryCode;


function onEnter() {
    if (props.modelValue || !props.required) {
        emits("continue");
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createBlock(InputWrapperWithIcon, {
    field: _ctx.field,
    required: _ctx.required,
    "icon-allowed": false
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(VuePhoneNumberInput, {
        "model-value": _ctx.modelValue,
        "onUpdate:modelValue": emitInput,
        placeholder: _unref(placeholder),
        ref_key: "input",
        ref: input,
        "hide-arrow": _ctx.required,
        "default-country-code": _unref(countryCode)
      }, null, 8, ["model-value", "placeholder", "hide-arrow", "default-country-code"]), [
        [
          _directive_on_native,
          onEnter,
          "keyup",
          { enter: true }
        ]
      ])
    ]),
    _: 1
  }, 8, ["field", "required"]))
}
}

})